export const TOGGLE_NAVBAR = 'TOGGLE_NAVBAR';

export function toggleNavbar() {
  return {
    type: TOGGLE_NAVBAR,
  };
}
